import InputAutocomplete from '@components/InputAutocomplete';
import { Box, Button, FormGroup, FormLabel, IconButton, Stack } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { ITalentSearchFilterOption } from '../types';

interface LanguageFilterProps {
  name: string;
  languageOptions: ITalentSearchFilterOption[];
  levelOptions: ITalentSearchFilterOption[];
}

const LanguageFilter = ({ name, languageOptions, levelOptions }: LanguageFilterProps) => {
  const { control } = useFormContext();

  const mappedLanguageOptions = languageOptions.map((option) => ({
    value: option.value,
    label: `${option.label} (${option.count})`,
  }));

  const mappedLevelOptions = levelOptions.map((option) => ({
    value: option.value,
    label: `${option.label} (${option.count})`,
  }));

  return (
    <FormGroup>
      <FormLabel>Langues</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const rows = field.value || [];

          const addRow = () => {
            field.onChange([...rows, { languageId: '', minLevelId: '' }]);
          };

          const removeRow = (index: number) => {
            field.onChange(rows.filter((_: any, i: number) => i !== index));
          };

          const updateRow = (index: number, key: string, value: string) => {
            const updated = [...rows];
            updated[index] = { ...updated[index], [key]: value };
            field.onChange(updated);
          };

          return (
            <Stack spacing={1}>
              {rows.map((row: any, index: number) => (
                <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <InputAutocomplete
                    id={`${name}-lang-${index}`}
                    name={`${name}-lang-${index}`}
                    options={mappedLanguageOptions}
                    value={mappedLanguageOptions.find((o: any) => o.value === row.languageId) || null}
                    onChange={(val) => updateRow(index, 'languageId', (val as string) || '')}
                    disableFormContext
                    sx={{ flex: 1 }}
                  />
                  <InputAutocomplete
                    id={`${name}-level-${index}`}
                    name={`${name}-level-${index}`}
                    options={mappedLevelOptions}
                    value={mappedLevelOptions.find((o: any) => o.value === row.minLevelId) || null}
                    onChange={(val) => updateRow(index, 'minLevelId', (val as string) || '')}
                    disableFormContext
                    sx={{ flex: 1 }}
                  />
                  <IconButton size="small" onClick={() => removeRow(index)}>
                    <i className="fi-br-cross-small" />
                  </IconButton>
                </Box>
              ))}
              <Button variant="text" size="small" onClick={addRow} sx={{ alignSelf: 'flex-start' }}>
                + Ajouter une langue
              </Button>
            </Stack>
          );
        }}
      />
    </FormGroup>
  );
};

export default LanguageFilter;
